// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2d5t4","requiredAsterisk":"Info_requiredAsterisk__27yD7"};